/**
 * Entry point. Imports global styles, registers the PWA service worker (flag-
 * gated), and boots the GameApp composition root. Instant play: no signup.
 */
import './style.css';
import { FEATURES } from './config/features';
import { GameApp } from './game';
import { installGestureGuard } from './input/gestureGuard';

// Suppress the browser's native pinch/double-tap zoom so it can't fight the
// game's own touch controls (the game's pinch-zoom uses ordinary touch events
// and keeps working). View-layer only; does not affect the simulation.
installGestureGuard();

const app = new GameApp();
app.start();

// Installable PWA: register the service worker only if the feature is on.
if (FEATURES.pwa && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const base = import.meta.env.BASE_URL ?? '/';
    navigator.serviceWorker.register(`${base}sw.js`).catch(() => {
      /* offline support is best-effort; ignore registration failures */
    });
  });
}
